export default __webpack_public_path__ + "static/financial-calendar-54bc3f6dbad1fb648bbcab94ddea3731.png";